var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h1",
    { style: _vm.style, attrs: { "data-test": "episode-title" } },
    [
      _vm.link
        ? _c(
            "a",
            {
              staticClass: "episode-title",
              attrs: {
                href: _vm.link,
                target: _vm.target,
                "data-test": "episode-title--link"
              }
            },
            [_vm._v(_vm._s(_vm.title))]
          )
        : _c(
            "span",
            {
              staticClass: "episode-title",
              attrs: { "data-test": "episode-title--text" }
            },
            [_vm._v(_vm._s(_vm.title))]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }